import React from "react";
import { Heading } from "../../../design/heading";
import { ToolbarProps } from "react-big-calendar";
import SelectViewComponent from "./SelectViewComponent";
import ChangeViewComponent from "./ChangeViewComponent";

const Toolbar: React.FC<ToolbarProps<object>> = (props) => {
  return (
    <div className="p-4 border-b border-zinc-200 dark:border-zinc-700 bg-zinc-50 dark:bg-zinc-800">
      {/* Header with current month/year */}
      <div className="toolbar-header">
        <Heading className="text-xl font-semibold text-center">
          {props.label}
        </Heading>
      </div>

      {/* Controls */}
      <div className="toolbar-controls">
        <div className="flex flex-wrap items-center justify-between gap-4 pb-4 md:gap-2">
          {/* View Selection - pass onView from toolbar props */}
          <div className="flex items-center gap-2">
            <span className="text-sm font-medium text-zinc-700 dark:text-zinc-300">
              View:
            </span>
            <SelectViewComponent
              currentView={props.view}
              onView={props.onView}
            />
          </div>

          {/* Navigation Controls */}
          <ChangeViewComponent {...props} />
        </div>
      </div>
    </div>
  );
};

export default Toolbar;
